import extend from 'lowscore/extend.js'

export default function discountsArray (discountsObject) {
  let discounts = Object.keys(discountsObject)
    .filter(k => k != 'promotions')
    .map(k => {
      return extend(discountsObject[k], {discountType: k})
    })
  if (discountsObject.promotions.applied) {
    var promotions = discountsObject.promotions.applied.map(p => {
      p.discountType = p.earlyBirdDepartureDaysId ? 'epd' : 'promotion'
      return p
    })
    discounts = discounts.concat(promotions)
  }
  return discounts
}
